import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(err) {
  const status = err?.response?.status;
  const d = err?.response?.data?.detail;
  // Cloudflare / gateway errors may return HTML → show a friendly message.
  if (typeof err?.response?.data === "string" && err.response.data.trim().startsWith("<")) {
    if (status === 502) return "Servizio temporaneamente non disponibile. Riprova tra qualche istante.";
    if (status === 429) return "Troppe richieste. Attendi qualche secondo e riprova.";
    return "Errore di rete. Riprova più tardi.";
  }
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return JSON.stringify(d);
}
